import type { CustomProxy } from '@unipile/types';
import { createContext } from 'react';

export interface LocationConfigState {
  [provider: string]: {
    custom_proxy?: CustomProxy;
    auto_proxy_config?: {
      country?: string;
    };
  };
}

export interface LocationConfigContextValue {
  locationConfig: LocationConfigState;
  setLocationConfig: (provider: string, config: { custom_proxy?: CustomProxy; auto_proxy_config?: { country?: string } }) => void;
  getLocationConfig: (provider: string) => { custom_proxy?: CustomProxy; auto_proxy_config?: { country?: string } };
  clearLocationConfig: (provider: string) => void;
}

export const LocationConfigContext = createContext<LocationConfigContextValue | undefined>(undefined);
LocationConfigContext.displayName = 'LocationConfigContext';
